function initHeroBannerSwiper() {
  const swiperEl = document.querySelector(".mySwiper");

  if (!swiperEl || typeof Swiper === "undefined") {
    return;
  }

  if (swiperEl.swiper) {
    swiperEl.swiper.destroy(true, true);
  }

  const slideCount = swiperEl.querySelectorAll(".swiper-slide").length;

  var swiper = new Swiper(".mySwiper", {
    loop: slideCount > 1, // desativa loop se tiver só 1 banner
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
    },
    autoplay: slideCount > 1 ? {
      delay: 6000,
      disableOnInteraction: false,
    } : false, // sem autoplay se tiver 1 só
    spaceBetween: 8,
    slidesPerView: 1,
  });

  // Pausar autoplay no hover (só se houver autoplay)
  if (slideCount > 1) {
    swiperEl.addEventListener("mouseenter", () => swiper.autoplay.stop());
    swiperEl.addEventListener("mouseleave", () => swiper.autoplay.start());
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initHeroBannerSwiper);
} else {
  initHeroBannerSwiper();
}

document.addEventListener("shopify:section:load", initHeroBannerSwiper);
